import { useNavigate } from 'react-router-dom'
import { X } from 'lucide-react'

export function ApprovalDetailHeader() {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-between bg-white border-b border-border px-8 py-4">
      <h1 className="text-xl font-bold text-foreground">
        Review Assortment Plan for Approval
      </h1>
      <button
        onClick={() => navigate('/approvals')}
        className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground cursor-pointer"
        title="Close"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  )
}
